/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { DormerColorViewModel } from "../../Order/Sections/Material/DormerColorViewModel";
import { PriceCalculationStrategyDto } from "../../Order/PriceCalculationStrategyDto";

export class DormerMaterialViewModel {
    id: string | null;
    name: string;
    dormerColors: DormerColorViewModel[];
    priceCalculationStrategy: PriceCalculationStrategyDto;
    priceCalculationStrategyId: string | null;
    configurationTemplateId: string;
}
